"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FieldsForm_1 = __importDefault(require("../FieldsForm"));
function EditorPreview(props) {
    return (react_1.default.createElement(FieldsForm_1.default, { choiceGroups: [], fields: props.fields, key: JSON.stringify(props.value), metadata: { selectedApi: props.selectedApi }, onCommitChange: () => { }, onLoadOptions: () => { }, value: props.value }));
}
exports.default = EditorPreview;
